// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5445":"ec1fde24","7337":"ad2866b8","8445":"bc98253f","9761":"ed0e4a1e"}[chunkId] || chunkId) + "." + {"1411":"d17b7a50a334e769","5243":"348ff4f5a15a4f1c","5445":"a48051f05a28b903","7337":"f1ede546df3bd613","8445":"f7ce5083a87527fa","9761":"6caa28ae8d17e7ab"}[chunkId] + ".js";
};